const firebaseConfig = {
    apiKey: "AIzaSyBaEweud2cjZVk9YV0A7pAXDgtXYrxNIGw",
    authDomain: "car-repair-c4e28.firebaseapp.com",
    projectId: "car-repair-c4e28",
    storageBucket: "car-repair-c4e28.appspot.com",
    messagingSenderId: "856977327309",
    appId: "1:856977327309:web:8244f8d7f5a9d000145584"
};
export default firebaseConfig;
